export default "__VITE_ASSET__db3a06be__"